<template>
  <div class="salary-result-statistics">
    <Selections
      v-if="values?.length"
      :label="valuesLabel"
      :values="values"
      :formatValues="formatValues"
      :small="true" />
    <div v-if="statistics.hasEnoughData" class="salary-result-statistics__stats-cards">
      <SalaryStatCard :number="statistics.p10" :label="p10Label" />
      <SalaryStatCard :number="statistics.median" :label="medianLabel" />
      <SalaryStatCard :number="statistics.average" :label="averageLabel" />
      <SalaryStatCard :number="statistics.p90" :label="p90Label" />
    </div>
    <InfoBox
      v-else
      :strongText="insufficientDataTitle"
      :text="insufficientDataText"
      :slim="true"
    />
  </div>
</template>

<script setup lang="ts">
import SalaryStatCard from "@shared/components/salary-stat-card/SalaryStatCard.vue";
import InfoBox from "@shared/components/info-box/InfoBox.vue";
import Selections from "@shared/components/selections/Selections.vue";

withDefaults(defineProps<{
  statistics: SalaryStatisticsValues;
  values?: string[] | null;
  valuesLabel?: string | null;
  formatValues?: boolean;
  p10Label?: string;
  medianLabel?: string;
  averageLabel?: string;
  p90Label?: string;
  insufficientDataTitle?: string;
  insufficientDataText?: string;
}>(), {
  values: () => [],
  valuesLabel: null,
  formatValues: true,
  p10Label: '',
  medianLabel: '',
  averageLabel: '',
  p90Label: '',
  insufficientDataTitle: '',
  insufficientDataText: '',
});
</script>
